import React, { useEffect, useMemo, useState } from "react";
// IMPORTS


const CmsPageProps = (props) => {
  const currentEnvironment = `${process.env.NEXT_PUBLIC_ENV_NAME}`;

  // METHODS

  // RENDER

  if (currentEnvironment === "prod" || !props || !props["components-list"]){
    return null;
  }
};

export default CmsPageProps;
